import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { Title } from '../General/Text';
import { TextP } from '../../Defaults/Text';
import { Tag, TagType } from '../Product/Tag';

interface Props {
  title: string;
  image: string;
  issaleout?: number;
  isnew: number;
  issale: number;
}

function ProductTitleImage({ title, image, issaleout, isnew, issale }: Props) {
  return (
    <Wrapper>
      <Title marginTop={0} marginBottom={24}>
        {title}
      </Title>
      <ImageWrapper imgSrc={image}>
        <TagWrapper>
          {isnew ? (
            <TagRelativeWrapper>
              <Tag text={'Novinka'} type={TagType.NEW} />
            </TagRelativeWrapper>
          ) : null}
          {issaleout ? (
            <TagRelativeWrapper>
              <Tag text={'Výpredaj'} type={TagType.SALEOUT} />
            </TagRelativeWrapper>
          ) : null}
          {issale ? (
            <TagRelativeWrapper>
              <Tag text={'Akcia'} type={TagType.ACTION} />
            </TagRelativeWrapper>
          ) : null}
        </TagWrapper>
      </ImageWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  color: #aaaaaa;
  position: relative;
  margin-right: ${rem(32)};

  &:focus-within {
    color: ${props => props.theme.colors.btnPrimary};
  }

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    margin-bottom: ${rem(8)};
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: initial;
  `}
`;

const ImageWrapper = styled.div<{ imgSrc: string }>`
  max-width: ${rem(328)};
  min-width: ${rem(288)};
  height: ${rem(328)};
  width: 100%;
  background-image: url('${({ imgSrc }) => imgSrc}');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  position: relative;
  margin-right: ${rem(32)};

  ${({ theme }) => theme.mediab.s450`
    min-width: initial;
    max-width: initial;
  `}
`;

const TagRelativeWrapper = styled.div`
  margin-right: ${rem(8)};
`;

const TagWrapper = styled(FlexRow)`
  position: absolute;
  top: ${rem(16)};
  left: ${rem(16)};
`;

export { ProductTitleImage };
